import React, { useMemo, useState } from "react";
import { getVoiceFromValue } from "../../../../constants/scriptConfig";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import VoiceOptionsList from "./VoiceOptionList";
import { useDispatch } from "react-redux";
import {
  updateCurrentElevanLabVoiceAccents,
  updateCurrentElevanLabVoiceAge,
  updateCurrentElevanLabVoiceGender,
} from "../../../../store/slides/slidesSlice";
import { useSelector } from "react-redux";
import { handleAccentVoice } from "../../../../thunks/editor/scriptThunks";

const ElevanlabsAccents = ({ onClose, onVoiceSelected }) => {
  const dispatch = useDispatch();

  const { currentSlideIndex, slides } = useSelector((state) => state.slides);
  const { selectedSlideData } = useSelector((state) => state.script);
  const { isFaceless } = useSelector((state) => state.project);

  const [accentVocie, setAccentVoice] = useState({
    accent: "american",
    gender: "female",
    age: "young",
    range: "0.3",
  });

  console.log("accentVocie", accentVocie);

  const {
    elevenLabsVoice,
    elevenLabsGender,
    elevenLabsAccents,
    elevenLabsAges,
  } = useSelector((state) => state.script);

  return (
    <div className="flex w-full h-full gap-10 relative">
      <div className="px-2 pr-0 py-4 w-4/5 bg-gray-100 overflow-auto">
        <div className="pb-1 h-full">
          <div
            htmlFor="scriptInput"
            className="w-full mb-4 text-sm text-gray-700 flex items-center"
          >
            <FontAwesomeIcon
              icon={faArrowLeft}
              onClick={onClose}
              className="mr-2 p-1 h-4 border-gray-500 border rounded-lg cursor-pointer"
            />
            <span className="text-gray-500 cursor-pointer" onClick={onClose}>
              BACK
            </span>
            <span className="font-bold ml-4">
              Choose Language and Accents for Accents Voice
            </span>
          </div>

          <div className="flex space-x-4 items-end">
            <div className="w-1/4">
              <label className="text-sm mb-2 block">Select Language</label>
              <select
                defaultValue={accentVocie.gender}
                onChange={(e) => {
                  const value = e.target.value;
                  setAccentVoice({
                    ...accentVocie,
                    gender: value,
                  });
                }}
                className="w-full p-2 border border-gray-300 text-xs rounded-lg"
              >
                {elevenLabsGender.map((gender, index) => (
                  <option key={index} value={gender.code}>
                    {gender.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="w-1/4">
              <label className="text-sm mb-2 block">Select Accent</label>
              <select
                defaultValue={accentVocie.accent}
                onChange={(e) => {
                  const value = e.target.value;

                  setAccentVoice({
                    ...accentVocie,
                    accent: value,
                  });
                }}
                className="w-full p-2 border border-gray-300 text-xs rounded-lg"
              >
                {elevenLabsAccents.map((accents, index) => (
                  <option key={index} value={accents.code}>
                    {accents.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="w-1/4">
              <label className="text-sm mb-2 block">Select Age</label>
              <select
                defaultValue={accentVocie.age}
                onChange={(e) => {
                  const value = e.target.value;
                  setAccentVoice({
                    ...accentVocie,
                    age: value,
                  });
                }}
                className="w-full p-2 border border-gray-300 text-xs rounded-lg"
              >
                {elevenLabsAges.map((age, index) => (
                  <option key={index} value={age.code}>
                    {age.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="w-full flex flex-col items-center mt-6">
            <input
              type="range"
              min="0.3"
              max="2"
              step="0.1"
              defaultValue="1"
              className="w-full h-2 bg-gray-200 rounded-lg cursor-pointer"
              style={{
                appearance: "none",
                height: "8px",
                borderRadius: "9999px",
                backgroundColor: "#E5E7EB",
                outline: "none",
              }}
              value={accentVocie.range}
              onChange={(e) =>
                setAccentVoice({ ...accentVocie, range: e.target.value })
              }
            />
            <div className="flex justify-between w-full mt-2 text-sm">
              <span>0.3</span>
              <span>2</span>
            </div>
          </div>

          <button
            className="inline-flex items-center px-4 py-2 border border-black text-xs lg:text-sm font-medium rounded-md shadow-sm text-black bg-transparent hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 absolute bottom-4 right-4"
            onClick={() => onVoiceSelected(accentVocie)}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default ElevanlabsAccents;
